<app-img-header
  title="Productos"
  alt="Daimler Truck"
  subTitle="Nuevo producto"
  image="/assets/images/cotizador/intro.jpg"
></app-img-header>
@if (isLoading) {
  <app-preloader></app-preloader>
}
<app-notifications></app-notifications>
<main class="main" id="product">
  <div id="detail">
    <div class="pageWidth">
      <form [formGroup]="form" class="dataAndPhoto">
        <div class="data">
          <div class="wrapperG4">
            <div class="controlWrapper nombreProducto">
              <label>Nombre del producto <span class="required">*</span></label>
              <input formControlName="name" />
            </div>
            <div class="controlWrapper tipoProducto">
              <label>Tipo de producto <span class="required">*</span></label>
              <div class="customSelect">
                <select formControlName="modelType" (change)="searchBrandsAndSubBrands()">
                  @for (type of financialCalculator.productType; track type.value) {
                    <option [value]="type.value">{{ type.name }}</option>
                  }
                </select>
              </div>
            </div>
            @if (!isAccesoriesProduct) {
              <div class="controlWrapper">
                <label>Marca <span class="required">*</span></label>
                <div class="customSelect">
                  <select formControlName="brandId" (change)="filterBrands()">
                    @for (brand of brands; track brand.id) {
                      <option [value]="brand.id">{{ brand.label }}</option>
                    }
                  </select>
                </div>
              </div>
            }
            @if (subBrands.length > 0 && this.form.get('brandId')) {
              <div class="controlWrapper">
                <label>{{ isAccesoriesProduct ? 'Modelo' : 'Submarca' }} <span class="required">*</span></label>
                <div class="customSelect">
                  <select formControlName="subBrandId" (change)="changeSubBrand($event)">
                    @for (subBrand of subBrands; track subBrand.id) {
                      <option [value]="subBrand.id">{{ subBrand.label }}</option>
                    } @empty {
                      <option [value]="null" selected hidden>Sin submarcas disponibles.</option>
                    }
                  </select>
                </div>
              </div>
            }
            <div class="controlWrapper">
              <label>Condición <span class="required">*</span></label>
              <div class="customSelect">
                <select formControlName="classification">
                  <option [value]="true">Nuevo</option>
                  <option [value]="false">Seminuevo</option>
                </select>
              </div>
            </div>
            <div class="controlWrapper">
              <label>Año<span class="required">*</span></label>
              <input formControlName="year" type="number" max="9999" />
              <span *ngIf="isYearMinValueNotValid" class="error">
                El producto no puede tener mas de 10 años de antiguedad.
              </span>
            </div>
            <div class="controlWrapper">
              <label>Precio de venta <span class="required">*</span></label>
              <div class="innerWrapper">
                <input
                  type="number"
                  id="price"
                  style="display: none"
                  (blur)="hideAmountInput('price')"
                  formControlName="price"
                  (keypress)="preventInvalidCharacters($event)"
                />
                <input
                  type="text"
                  id="hidden-price"
                  (focus)="showAmountInput('price')"
                  style="display: block"
                  [value]="form.controls['price'].value | currency: '' : ''"
                />
              </div>
            </div>

            <div class="controlWrapper">
              <label>Precio máximo <span class="required">*</span></label>
              <div class="innerWrapper">
                <input
                  type="number"
                  id="maxPrice"
                  style="display: none"
                  (blur)="handleMaxPriceChange()"
                  formControlName="maxPrice"
                  (keypress)="preventInvalidCharacters($event)"
                />
                <input
                  type="text"
                  id="hidden-maxPrice"
                  (focus)="showAmountInput('maxPrice')"
                  style="display: block"
                  [value]="form.controls['maxPrice'].value | currency: '' : ''"
                />
              </div>
            </div>

            <div class="controlWrapper">
              <label>Moneda <span class="required">*</span></label>
              <div class="customSelect">
                <select formControlName="currency">
                  @for (currency of currencies; track currency.value) {
                    <option [value]="currency.value">{{ currency.type }}</option>
                  }
                </select>
              </div>
            </div>

            <div class="controlWrapper">
              <label>ID para seguro <span class="required">*</span></label>
              <input formControlName="modelCode" />
            </div>
            <label class="switch gapTop">
              <input type="checkbox" formControlName="enabled" />
              <span class="knob"></span>
              <span class="base"></span>
              <span class="description">Estado activo</span>
            </label>
          </div>
        </div>
        <!-- Imagen -->
        <div class="photo">
          @if (productImg() !== '') {
            <picture>
              <img
                [src]="productImg()"
                width="218"
                height="132"
                alt="Subrand model image"
                decoding="async"
                loading="lazy"
              />
            </picture>
          } @else {
            <div class="noImage">
              <span>Sin imagen</span>
            </div>
          }
        </div>
      </form>
      <div id="valorResidual">
        <h2>Valor residual</h2>
        <div class="tableWrapper">
          <div class="noData" *ngIf="residualValue.length == 0">No hay información disponible</div>
          <div class="customTable valorResidual" *ngIf="residualValue.length != 0">
            <div class="header">
              <div class="cell periodo">Período</div>
              <div class="cell daimler">Garantía Daimler</div>
              <div class="cell terceros">Garantía Terceros</div>
              <div class="cell acciones"></div>
            </div>
            <div class="row" *ngFor="let value of residualValue; let i = index">
              <div class="cell periodo">{{ value.term }} meses</div>
              <div class="cell daimler">
                <span>{{ value.daimlerRate }}%</span>
                <span>{{ value?.daimlerFixedAmount | currency: '' : '' }} MXN</span>
              </div>
              <div class="cell terceros">
                {{ value.externalsMinRate }}% <span class="min">Min</span> {{ value.externalsMaxRate }}%
                <span>Max</span>
              </div>
              <div class="cell acciones">
                <a tp="Editar" (click)="editResidualValue(value, i)" class="edit">Editar</a>
                <a tp="Eliminar" (click)="deleteResidualValue(value)" class="delete">Eliminar</a>
              </div>
            </div>
          </div>
          <div class="actionsWrapper">
            <button class="tertiary" (click)="openModal()"><i class="icon"></i> Nuevo valor residual</button>
          </div>
        </div>
      </div>
      <div class="actions">
        <div class="wrapper">
          <button type="button" class="secondary" (click)="cancel()">Cancelar</button>
          <button type="button" class="secondary" (click)="cancel()">Volver</button>
          <button type="submit" class="primary" (click)="save()" [disabled]="this.form.invalid">Guardar</button>
        </div>
      </div>
    </div>
  </div>
</main>

<ng-template #modalTemplate>
  <app-new-financial-product-template
    [maxPrice]="form.controls['maxPrice'].value"
    [currentResidualValue]="residualValue"
    (save)="handleSave($event)"
  ></app-new-financial-product-template>
</ng-template>
